<template>
  <v-app>
    <v-container class="my-16">
      <view-intro heading="Асуулгын үр дүн" link="components/simple-tables" />
      <v-container>
        <v-row justify="end">
          <v-col cols="3">
            <v-text-field
              label="Эцсийн оноог шүүx"
              v-model="filterMinLimit"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
      <material-card icon="mdi-clipboard-text" icon-small color="accent">
        <v-simple-table v-if="users">
          <thead>
            <tr>
              <th class="primary--text">ID</th>
              <th class="primary--text">Овог</th>
              <th class="primary--text">Нэр</th>
              <th class="primary--text">Имэйл</th>
              <th class="primary--text">Date</th>
              <th
                class="primary--text text-center"
                v-for="(categeory, index) in categories"
                v-bind:key="index"
              >
                БҮЛЭГ-{{ categeory.name }}
              </th>
              <th class="text-right primary--text">Нийт оноо</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(userr, index) in users"
              v-bind:key="index"
              @click="_detail(userr, index)"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ userr.firstName }}</td>
              <td>{{ userr.lastName }}</td>
              <td>{{ userr.email }}</td>
              <td>{{ _getDate(userr) | moment("YYYY/MM/DD, h:mm") }}</td>
              <template v-if="userr.asuulga && userr.asuulga[0].categories">
                <td
                  class="text-center"
                  v-for="(cat, catindex) in userr.asuulga[0].categories"
                  v-bind:key="catindex"
                >
                  {{ cat.catScored }}
                </td>
              </template>
              <td class="text-right" v-if="userr.asuulga">
                <v-chip :color="getColor(userr.asuulga[0].totalScore)" dark>
                  {{ userr.asuulga[0].totalScore }}
                </v-chip>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </material-card>
    </v-container>
    <v-dialog v-model="showDetail" max-width="40%" v-if="selectedItem">
      <!-- xTODO set button under scroll-->
      <v-card height="100%">
        <v-row no-gutters scrollable>
          <v-col md="6" offset-md="3">
            <div
              v-for="(cat, catindex) in selectedItem.asuulga[0].categories"
              v-bind:key="catindex"
            >
              <br />
              <v-btn
                elevation="0"
                class="py-4 font-weight-bold my-0"
                color="primary"
              >
                БҮЛЭГ. {{ cat.name }}</v-btn
              >
              <div>
                <v-card
                  class="pa-2 mt-0 mb-2"
                  outlined
                  tile
                  v-for="(question, qindex) in cat.questions"
                  :key="qindex"
                >
                  <h4>{{ qindex + 1 }}. {{ question.name }}</h4>
                  <v-list>
                    <v-list-item
                      class="px-1"
                      v-for="answer in question.answers"
                      :key="answer.id"
                    >
                      <v-list-item-avatar class="mr-0">
                        <v-icon
                          v-if="answer.answered == true"
                          style="color: red"
                        >
                          mdi-checkbox-marked-circle
                        </v-icon>
                        <v-icon v-else>
                          mdi-checkbox-blank-circle-outline
                        </v-icon>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title
                          class="text-wrap"
                          v-text="answer.name"
                        />
                      </v-list-item-content>

                      <v-list-item-action v-if="answer.score">
                        <p>{{ answer.score }}</p>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-card>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-card-actions class="justify-center">
          <v-spacer />
          <v-btn color="green darken-1" text @click="dialog1 = false">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../firebaseConfig.js");

export default {
  props: {
    asuulgaId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    users: null,
    showDetail: false,
    selectedItem: null,
    selectedIndex: -1,
    prePath: "asuumj/",
    filterMinLimit: 0,
  }),
  watch:{
    filterMinLimit: function(val){
      console.log(val, this.filterMinLimit)
      for(var uuser of this.users){
        filteredUsers.push()
      }
    }
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  created() {
    this._findCategories();
    fb.db.collection("users").onSnapshot((querySnapshot) => {
      this.users = [];
      querySnapshot.forEach((doc) => {
        console.log(doc.data());
        let uuser = doc.data();
        uuser.id = doc.id;
        uuser.ref = doc.ref;
        this.users.push(uuser);
      });
    });
  },
  methods: {
    _detail(item, index) {
      console.log(item);
      this.showDetail = true;
      this.selectedItem = item;
      this.selectedIndex = index;
    },
    _getDate(user) {
      if (user.createdAt) return new Date(user.createdAt.toDate());
    },

    _getCategoryScore(asuulga) {
      var scores = [];
      for (var cat of asuulga.categories) {
        scores.push(cat.scored);
      }
      return scores;
    },
    _getCategoryScoreOfUser(user) {
      if (user.asuulga) {
        for (var asuu of user.asuulga) {
          if (asuu.asuulgaId == this.asuulgaId) {
            return this._getCategoryScore(asuu);
            //return -2;
          }
        }
      } else return -3;

      return -1;
    },
    _getCategories(user) {
      if (user.asuulga) {
        for (var asuu of user.asuulga) {
          console.log(asuu.categories);
          if (asuu.asuulgaId == this.asuulgaId) {
            return [1, 2];
          }
        }
      } else return [];

      return [];
    },
    async _findCategories() {
      fb.db
        .collection(this.prePath + this.asuulgaId + "/categories")
        .orderBy("name", "asc")
        .onSnapshot((querySnapshot) => {
          this.categories = [];
          querySnapshot.forEach((catDoc) => {
            const cat = catDoc.data();
            cat.id = catDoc.id;
            cat.questions = [];
            //this._getQuestionsOfCategory(cat);
            this.categories.push(cat);
            console.log(cat);
          });
        });
    },
    getColor(score) {
      if (score > 10) return "green";
      else if (score > 5) return "orange";
      else return "red";
    },
  },
};
</script>
